/* ARCELF — client-side language toggle (JA / EN / FR)
   Shows the matching [data-arcelf-i18n] blocks and remembers the choice.
   Used for hand-curated trilingual copy without Markets/Translate&Adapt. */
(function () {
  var KEY = 'arcelf-lang';
  var ALLOWED = ['ja', 'en', 'fr'];

  function current() {
    try { var v = localStorage.getItem(KEY); if (ALLOWED.indexOf(v) > -1) return v; } catch (e) {}
    return document.documentElement.getAttribute('data-arcelf-lang') || 'ja';
  }

  function apply(lang) {
    if (ALLOWED.indexOf(lang) < 0) lang = 'ja';
    var html = document.documentElement;
    html.setAttribute('data-arcelf-lang', lang);
    html.setAttribute('lang', lang);
    try { localStorage.setItem(KEY, lang); } catch (e) {}
    document.querySelectorAll('[data-arcelf-lang]').forEach(function (btn) {
      if (!btn.matches('button')) return;
      var active = btn.getAttribute('data-arcelf-lang') === lang;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function init() {
    apply(current());
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-arcelf-lang]');
      if (!btn) return;
      e.preventDefault();
      apply(btn.getAttribute('data-arcelf-lang'));
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
